<template>
    <div ref="dropdown" class="dropdown">
        <div class="p-3 border border-secondary rounded d-flex flex-row dropdown-toggle"
             type="button"
             data-toggle="dropdown"
             aria-haspopup="true"
             aria-expanded="false"
        >
            <div v-if="!selectedStore" class="flex-grow-1">
                Select store
            </div>
            <div v-else class="flex-grow-1 d-flex flex-row gap-2">
                <StoreImage class="h-3em w-75px" :store="selectedStore"/>
                <div class="d-flex flex-column justify-content-center">
                    {{ selectedStore.attributes.name }}
                    <div class="font-size-sm font-weight-light">
                        <StoreAddress :store="selectedStore"/>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column justify-content-center">
                <div class="px-2">
                    <i class="fas fa-chevron-down"/>
                </div>
            </div>
        </div>
        <Transition>
            <div class="dropdown-menu mt-1" aria-labelledby="dropdownMenuButton">
                <div class="px-5 pb-2">
                    <input ref="searchInput"
                           class="form-control form-control-sm form-control-transparent p-0 border-0"
                           type="text"
                           placeholder=" Search store"
                           v-model="searchString"
                           @keyup.enter="selectFirstSearchResult"
                    >
                </div>
                <div v-for="store in filteredStores"
                     :key="store.id"
                     class="dropdown-item cursor-pointer border-top border-top-dotted"
                     :class="{'active': store.id === selectedStore?.id || filteredStores.length === 1}"
                     @click="selectStore(store)"
                >
                    <div class="d-flex flex-column">
                        <div>
                            {{ store.attributes.name }}
                        </div>
                        <div class="font-size-sm font-weight-light">
                            <StoreAddress :store="store"/>
                        </div>
                    </div>
                </div>
                <div v-if="filteredStores.length === 0" class="font-italic font-weight-bold py-1 px-5 text-warning">
                    No stores found
                </div>
            </div>
        </Transition>
    </div>
</template>

<script>
import StoreImage from "./StoreImage.vue";
import StoreAddress from "./StoreAddress.vue";

export default {
    components: {StoreAddress, StoreImage},

    props: {
        stores: Array,
        value: Object
    },

    data() {
        return {
            searchString: '',
            selectedStore: this.value
        }
    },

    mounted() {
        $(this.$refs.dropdown).on('shown.bs.dropdown', e => this.focusSearchInput()) //TODO: get rid of jQuery events
    },

    methods: {
        selectStore(store) {
            this.searchString = '';
            this.selectedStore = store
            this.$emit('input', store)
        },

        focusSearchInput() {
            this.$refs.searchInput.focus()
        },

        selectFirstSearchResult() {
            if (this.filteredStores.length > 0) {
                this.selectStore(this.filteredStores[0]);
                $(this.$refs.dropdown).dropdown('toggle') //TODO: get rid of jQuery events
            }
        }
    },

    computed: {
        filteredStores() {
            if (this.searchString.trim().length === 0) {
                return this.stores;
            }

            let stores = [];
            for (let store of this.stores) {
                for (let searchPart of this.searchString.trim().toLowerCase().split(" ")) {
                    if (store.attributes.name.toLowerCase().includes(searchPart)) {
                        stores.push(store);
                    } else if (store.attributes.address.city.toLowerCase().includes(searchPart)) {
                        stores.push(store);
                    } else if (store.attributes.address.street1.toLowerCase().includes(searchPart)) {
                        stores.push(store);
                    } else if (store.attributes.address.postcode.toLowerCase().includes(searchPart)) {
                        stores.push(store);
                    }
                }
            }

            return stores;
        }
    }
}
</script>

<style>
.show .dropdown-toggle {
    background-color: var(--primary) !important;
    border-color: var(--primary) !important;
    color: white;
}

.dropdown-toggle::after {
    display: none;
}

.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
